export default {
  SET_REVIEWS: "SET_REVIEWS",
  SET_REVIEWED: "SET_REVIEWED",
};
